import { Box, Typography } from '@mui/material';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';
import { FullGcfComponentSection } from 'src/components/gcfComponentSection';
import { Progress } from 'src/components/progress';
import { ScaleContainer } from 'src/components/scaleContainer/ScaleContainer';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { ComponentTypes } from 'src/interfaces';
import { getComponentDisplayName, lang } from 'src/utils';
import { getSectionPreviewData } from 'src/utils/gcf-helper';

import { ComponentPreviewSidebarProps } from './ComponentPreviewSidebar.interface';
import {
  Container,
  DetailsContainer,
  PreviewContainer,
} from './ComponentPreviewSidebar.styled';

export const ComponentPreviewSidebar = ({
  highlightedComponent,
  componentTags,
  productFilters,
  productVariationFilters,
  skipProductsApiOnEmptyFilters,
  hasOOOverride,
}: ComponentPreviewSidebarProps) => {
  if (!highlightedComponent) {
    return (
      <Container>
        <Progress />
      </Container>
    );
  }

  return (
    <Container>
      <PreviewContainer container>
        <ScaleContainer
          containerStyle={{
            height: '100%',
            minWidth: '100%',
          }}>
          <FullGcfComponentSection
            assemblyComponents={[
              {
                component: {
                  type: highlightedComponent?.component_type?.name,
                  config: highlightedComponent?.config,
                  name: highlightedComponent?.name,
                  width: highlightedComponent?.width,
                  height: highlightedComponent?.height,
                  theme: highlightedComponent?.theme?.name,
                },
              },
            ]}
            height={highlightedComponent?.height || 0}
            width={highlightedComponent?.width || 0}
            previewData={getSectionPreviewData(
              highlightedComponent?.component_type?.name as ComponentTypes,
            )}
            containerStyle={{
              borderWidth: '1px',
              borderStyle: 'solid',
              borderColor: 'brand.darkGrey',
            }}
            productFilters={productFilters}
            productVariationFilters={productVariationFilters}
            skipProductsApiOnEmptyFilters={skipProductsApiOnEmptyFilters}
          />
        </ScaleContainer>
      </PreviewContainer>

      <>
        <CustomTooltip
          width={500}
          placement="bottom"
          overflowLineNumber={2}
          title={highlightedComponent?.name}>
          <Typography fontSize="24px" fontWeight="500">
            {highlightedComponent?.name}
          </Typography>
        </CustomTooltip>
        <DetailsContainer>
          <Box>
            <Typography variant="body2" color="grey.600">
              {lang.type}
            </Typography>
            <Typography variant="body1">
              {getComponentDisplayName(
                highlightedComponent?.component_type?.name as ComponentTypes,
              )}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="grey.600">
              {lang.size}
            </Typography>
            <Typography variant="body1">{`${highlightedComponent?.width}x${highlightedComponent?.height}`}</Typography>
          </Box>
        </DetailsContainer>
        {hasOOOverride && (
          <DetailsContainer>
            <Box>
              <Typography variant="body2" color="grey.600">
                {lang.tags}
              </Typography>
              <Typography
                variant="body1"
                display="flex"
                flexWrap="wrap"
                gap={1}>
                {componentTags?.map((tag) => (
                  <DynamicTooltipChip
                    key={tag.id}
                    chipName={tag.name}
                    tooltipTitle={tag.name}
                    tooltipWidth={500}
                    tooltipActivationWidth={200}
                    tooltipPlacement="top"
                  />
                ))}
              </Typography>
            </Box>
          </DetailsContainer>
        )}
      </>
    </Container>
  );
};
